<template>
  <main class="main">
    <!-- Banner -->
    <section class="banner banner--model little--grey">
      <div class="container">
        <div class="inner align--top">
          <div class="item">
            <div class="nav__links" :class="{'sticky': isSticky}">
              <h1>{{ company.header.title }}</h1>
              <scrollactive ref="scrollactive" active-class="sticky-active" :alwaysTrack="false" :offset="80" :clickToScroll="true">
                <ul class="nav__offer">
                    <router-link :to="'/'" exact tag="li">
                      <a class="nav__backMenu"><img src="../assets/logo-simple.svg" alt=""></a>
                    </router-link>
                    
                    <router-link v-for="(item, index) in company.subnav" :key="index" :to="item.link" tag="li">
                      <a class="scrollactive-item">{{ item.name }}</a>
                    </router-link>
                </ul>
              </scrollactive>
            </div>
          </div>
          <div class="item">
            <img src="../assets/perso/men3.png" alt="">
          </div>
        </div>
        
      </div>
      <div class="mask"></div>
    </section>
    <section class="banner banner--form">
      <div class="container">
        <!-- About us -->
        <h2 id="about-us">{{company.section.aboutUs.title}}</h2>
        <p>{{company.section.aboutUs.p1}}</p>
        <p>{{company.section.aboutUs.p2}}</p>
        <p>{{company.section.aboutUs.p3}}</p>
        <p>{{company.section.aboutUs.p4}}</p>
        <h2 id="offices">{{company.section.offices.title}}</h2>
        <div class="Grid small-Grid--full large-Grid--1of3 med-Grid--1of3 Grid--full">
        <template v-for="item in company.section.offices.office">
          <div class="Grid-cell" style="padding-bottom:20px">
          <strong>{{ item.title}} </strong><br/><br/>
          <span v-html="item.address"></span><br/><br/>
          <span>{{ item.phone}}</span>
        </div>
        </template>
        </div>
        


        <!-- Contact -->
        <h2 id="connect-with-us">CONNECT WITH US</h2>
        <div class="typeform-widget" style="height:500px;overflow:hidden"></div>

        

      </div>
      <div class="mask"></div>
    </section>
  </main>
</template>

<script>
import axios from 'axios'
import Company from '../contents/company.json'
export default {
  data () {
    return {
      company: Company,
      isSticky: false,
      ticking: false,
      lastPositionScroll: 0,
      connectWithUs: '',
      demoContact: '',
      formDemo: false,
      formDemo2: false,
      formQuestion: false,
      formQuestion2: false,
      questionStep1: true,
      questionStep2: false,
      formHello: false,
      formQuote: false,
      formPartner: false,
      demoFieldsYes: {
        'source': 'Request a demo - Phone',
        'firstName': '',
        'name': '',
        'jobTitle': '',
        'phoneNumber': '',
        'company': '',
        'freeField': ''
      },
      demoFieldsNo: {
        'source': 'Request a demo - Email',
        'freeField': '',
        'email': ''
      },
      questionFields: {
        'source': 'Ask a question',
        'freeField': '',
        'name': '',
        'firstName': '',
        'workEmail': '',
        'company': '',
        'jobTitle': '',
        'phoneNumber': ''
      },
      helloFields: {
        'source': 'Say hello',
        'freeField': ''
      },
      quoteFields: {
        'source': 'Request a quote',
        'hrCycle': '',
        'companySize': '',
        'freeField': ''
      },
      partnerFields: {
        'source': 'Partner program',
        'companyUrl': '',
        'companySize': '',
        'mainActivity': '',
        'firstName': '',
        'name': '',
        'jobTitle': '',
        'phoneNumber': ''
      },
      errorPost: []
    }
  },
  methods: {
    setStickyClass (positionScroll) {
      let elm = document.querySelector('.banner--model')
      let heightElm = elm.clientHeight
      if (positionScroll >= heightElm) {
        this.isSticky = true
      } else {
        this.isSticky = false
      }
    },
    invokeTypeform () {
      const typeformEmbed = require('@typeform/embed')
      const embedElement = document.querySelector('.typeform-widget')
      typeformEmbed.makeWidget(
        embedElement,
        'https://jurgennoel.typeform.com/to/LCuADW',
        {
          hideScrollbars: true,
          hideFooter: true
        }
      )
    },
    validateForm (scope) {
      // let _this = this
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          switch (scope) {
            case 'formDemo':
              this.formDemo = true
                // Fake service, replace url by your own
                // @object to send => this.demoFieldsYes
              axios.post(`/ajax/sendmail_long.php`, {
                body: this.demoFieldsYes
              })
                .then(response => {
                  console.log(response)
                })
                .catch(e => {
                  this.errorPost.push(e)
                })
              break

            case 'formDemo2':
              this.formDemo2 = true
                // Fake service, replace url by your own
                // @object to send => this.demoFieldsNo
              axios.post(`/ajax/sendmail_long.php`, {
                body: this.demoFieldsNo
              })
                .then(response => {
                  console.log(response)
                })
                .catch(e => {
                  this.errorPost.push(e)
                })
              break
            case 'formQuestion':
              this.formQuestion = true
              this.questionStep1 = false
              this.questionStep2 = true
              break
            case 'formQuestion2':
              this.formQuestion2 = true
              this.questionStep2 = true
                // Fake service, replace url by your own
                // @object to send => this.questionFields
              axios.post(`/ajax/sendmail_long.php`, {
                body: this.questionFields
              })
                .then(response => {
                  console.log(response)
                })
                .catch(e => {
                  this.errorPost.push(e)
                })
              break
            case 'formHello':
              this.formHello = true
                // Fake service, replace url by your own
                // @object to send => this.helloFields
              axios.post(`/ajax/sendmail_long.php`, {
                body: this.helloFields
              })
                .then(response => {
                  console.log(response)
                })
                .catch(e => {
                  this.errorPost.push(e)
                })
              break
            case 'formQuote':
              this.formQuote = true
                // Fake service, replace url by your own
                // @object to send => this.quoteFields
              axios.post(`/ajax/sendmail_long.php`, {
                body: this.quoteFields
              })
                .then(response => {
                  console.log(response)
                })
                .catch(e => {
                  this.errorPost.push(e)
                })
              break
            case 'formPartner':
              this.formPartner = true
                // Fake service, replace url by your own
                // @object to send => this.partnerFields
              axios.post(`/ajax/sendmail_login.php`, {
                body: this.partnerFields
              })
                .then(response => {
                  console.log(response)
                })
                .catch(e => {
                  this.errorPost.push(e)
                })
              break

            default:
              break
          }
        }

        // TODO : Send object value to WS/backend.
        // @object to send => this.inputName
      })
    }
  },
  mounted () {
    window.addEventListener('scroll', (e) => {
      this.lastPositionScroll = window.scrollY
      if (!this.ticking) {
        window.requestAnimationFrame(() => {
          this.setStickyClass(this.lastPositionScroll)
          this.ticking = false
        })
      }
      this.ticking = true
    })
  },
  updated () {
    this.invokeTypeform()
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/pages/Company.vue